export const SUPER_ADMIN_EMAIL = "kwin@gmail.com";
export const SUPER_ADMIN_HASHED_PASSWORD = "e14cb9e5c0eeee0ea313a4e04fbd10aa17ac17aa33a3cad4bdfe74b87ca18ef8";